import React from 'react';
import { useReveal } from '../lib/useReveal';
const COST_DATA = [{
  without: 'Años cargando emociones que no son tuyas',
  cost: 'Energía que no vuelve'
}, {
  without: 'Patrones que se repiten en cada relación',
  cost: 'Tiempo y vínculos dañados'
}, {
  without: 'Sin método para leer tu árbol',
  cost: 'Confusión que se cronifica'
}, {
  without: 'Sin protocolo de límites',
  cost: 'Relaciones que te drenan'
}, {
  without: 'Sin permiso para brillar',
  cost: 'Ingresos y proyectos que no despegan'
}, {
  without: 'El mismo ciclo de culpa y postergación',
  cost: 'El próximo año — igual que este'
}];
export function CostComparisonSection() {
  const [ref1, vis1] = useReveal();
  return <section className="bg-[#1C1410] py-12 md:py-16 px-5 sm:px-6 border-t border-[#C9A96E]/10" data-id="element-98">
      <div className="container mx-auto max-w-3xl" data-id="element-99">
        <div ref={ref1} className={`reveal ${vis1 ? 'is-visible' : ''}`} data-id="element-100">
          <div className="text-center mb-10" data-id="element-101">
            <h2 className="text-2xl md:text-4xl font-bold text-[#F5ECD7] mb-4" style={{
            fontFamily: "'Playfair Display', serif"
          }} data-id="element-102">
              ⚖️ ¿CUÁNTO CUESTA NO TENERLO?
            </h2>
          </div>

          <div className="bg-[#2D1B1B] rounded-2xl border border-[#C9A96E]/20 overflow-hidden shadow-xl" data-id="element-103">
            <div className="grid grid-cols-2 bg-[#1C1410]/50 border-b border-[#C9A96E]/20" data-id="element-104">
              <div className="p-4 md:p-5 text-center" data-id="element-105">
                <span className="text-[#FAF3E8] font-bold text-sm uppercase tracking-wider" data-id="element-106">
                  Sin El Código
                </span>
              </div>
              <div className="p-4 md:p-5 text-center border-l border-[#C9A96E]/20" data-id="element-107">
                <span className="text-[#C4856A] font-bold text-sm uppercase tracking-wider" data-id="element-108">
                  Costo real
                </span>
              </div>
            </div>

            <div className="divide-y divide-[#C9A96E]/10" data-id="element-109">
              {COST_DATA.map((row, idx) => <div key={idx} className="grid grid-cols-2 hover:bg-[#F5ECD7]/[0.02] transition-colors" data-id="element-110">
                  <div className="p-4 md:p-5 flex items-center justify-center text-center" data-id="element-111">
                    <span className="text-[#FAF3E8] text-sm" data-id="element-112">
                      {row.without}
                    </span>
                  </div>
                  <div className="p-4 md:p-5 border-l border-[#C9A96E]/10 flex items-center justify-center text-center bg-[#8B2635]/5" data-id="element-113">
                    <span className="text-[#D4A5A5] font-medium text-sm" data-id="element-114">
                      {row.cost}
                    </span>
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}